<script setup lang="ts">
import { Recycle } from "@lucide/vue";

// Reuse is a separate on/off flag, not a life-cycle stage. A switch (rather than a pill) keeps it
// visually distinct from the stage chips. Styled locally with the brand green (app-green-500) so
// only this toggle uses it, without recolouring the shared Switch's "positive" everywhere.
const props = defineProps<{
  value: boolean | undefined;
  disabled: boolean;
}>();

const emits = defineEmits<{
  update: [payload: boolean];
}>();

const toggle = () => {
  if (props.disabled) return;
  emits("update", !props.value);
};
</script>

<template>
  <div class="flex items-center gap-2 self-start">
    <Recycle
      class="icon-sm"
      :class="value ? 'text-app-green-500' : 'text-type-muted'"
      :stroke-width="1.5" />
    <span class="t-small text-type-default">Reuse</span>
    <button
      type="button"
      role="switch"
      :aria-checked="value || false"
      :disabled="disabled"
      class="focus-ring duration-fast ease-standard relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors"
      :class="[value ? 'bg-app-green-500' : 'bg-slate-200', { 'interactive-disabled': disabled }]"
      @click="toggle">
      <span
        class="bg-slate-0 duration-fast ease-standard h-5 w-5 rounded-full transition-transform"
        :class="value ? 'translate-x-[22px]' : 'translate-x-[2px]'" />
    </button>
  </div>
</template>
